import qs from 'querystring'
import Api from '../lib/request'
import CONSTANT from '../constant/cookie'
import _ from 'underscore'
import cookie from '../lib/cookie'
import op from 'object-path'
const matchCardTotal = (data) => {
    return new Promise( (resolve, reject)=> {
        let url = CONSTANT.REQUEST_HOST
        data = JSON.stringify(data)

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.order.card.match-total.v2',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const orderCardCheck = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.card.check',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            if(op(data).get('data.checkStatus') !== 0){
                return reject(op(data).get('data.checkMsg'))
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const matchOrderCardList = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.card.personal-match.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status == 6003) {
                return resolve([])
            }
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const orderCardListOptimal = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.card.optimal',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getPreorderInfo = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.common.get-cache',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getPreorderSkus = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.product.sku-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getPreorderSkuExtend = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.order.sku-extend.v2',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getFilmOrder = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.ticket.order.detail',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const createOrder = (data) => {
    return new Promise( (resolve, reject)=> {
        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.create.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const cashPay = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.pay',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const cancelTicketOrder = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.ticket.order.cancel',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getDesignatedCards = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.card.match.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getPayLimit = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.pay-limit.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const orderCouponList = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.coupon-list.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getOrderCouponNum = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.order.coupon-count.v2',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const orderOptimalPay = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.order.optimal-pay.v2',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const orderCheckPay = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.check-pay.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const checkLogistics = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
              'X-Host':'mall.order.logistics-check',
              'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getSkuListByPreId = (data) => {
  return new Promise((resolve, reject) => {

    data = JSON.stringify(data)
    let url = CONSTANT.REQUEST_HOST

    Api.post(url, data, {
      headers: {
        'X-Host': 'mall.order.pre-order.info',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
      }
    })
      .then((data) => {
        if (data.status !== 0) {
          return reject(data)
        }
        resolve(data.data)
      },
        (e) => {
          reject(e)
        })
  })
}

const preorderVerify = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.verify.v2',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getCashPayWay = (data) => {
    return new Promise( (resolve, reject)=> {

        let query = ''
        if(!_.isEmpty(data)){
            query = `?${qs.stringify(data)}`
        }
        let url = `${CONSTANT.REQUEST_HOST}${query}`

        Api.get(url ,{
            headers: {
                'X-Host':'mall.order.pay.way',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getTiedProduct = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.tied-product',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getOrderStoreList = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.store-list',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const onOrderEvent = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.event',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getExamineAgencyListOfPreorder = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.examine-agency',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getGiftOrderSkuExtend = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.gift-order.sku-extend',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const checkGiftOrderLogistics = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.gift-order.logistics-check',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
const getOrderRemindMsg = (data) => {
    return new Promise( (resolve, reject)=> {

        data = JSON.stringify(data)
        let url = CONSTANT.REQUEST_HOST

        Api.post(url ,data,{
            headers: {
                'X-Host':'mall.order.remind-msg',
                'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN),
            }
        })
        .then((data) => {
            if(data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        },
        (e)=> {
            reject(e)
        })
    })
}
/*yeoman-template-point-1*/
export default {
    matchCardTotal,
    orderCardCheck,
    matchOrderCardList,
    orderCardListOptimal,
    getPreorderInfo,
    getPreorderSkus,
    getPreorderSkuExtend,
    getFilmOrder,
    createOrder,
    cashPay,
    cancelTicketOrder,
    getDesignatedCards,
    getPayLimit,
    orderCouponList,
    getOrderCouponNum,
    orderOptimalPay,
    orderCheckPay,
    checkLogistics,
    getSkuListByPreId,
    preorderVerify,
    getCashPayWay,
    getTiedProduct,
    getOrderStoreList,
    onOrderEvent,
    getExamineAgencyListOfPreorder,
    getGiftOrderSkuExtend,
    checkGiftOrderLogistics,
    getOrderRemindMsg,
/*yeoman-template-point-2*/
}
